import React, { useState } from "react";
import AmolSir from "../images/Amol_Sir.png";
import PallaviMam from "../images/Pallavi_Mam.png";
import SnehalMam from "../images/Snehal_Mam.png";
import OmkarSir from "../images/Omkar_Sir.png";

const directors = [
  {
    name: "Mr. AMOL R.G. PATIL",
    position: "Managing Director",
    image: AmolSir,
  },
  {
    name: "Dr. PALLAVI SHAH",
    position: "Chair Person",
    image: PallaviMam,
  },
  {
    name: "Adv. SNEHAL JADHAV",
    position: "Legal Advisor",
    image: SnehalMam,
  },
  {
    name: "Mr. OMKAR PATIL",
    position: "Chair Person",
    image: OmkarSir,
  },
];

const BoardOfDirectors = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null); // To track hovered director

  const directorsContainerStyle = {
    padding: "20px",
    backgroundColor: "#f5f7fa",
  };

  const directorsTitleStyle = {
    textAlign: "center",
    fontSize: "32px",
    color: "#5a2a18",
    marginBottom: "30px",
    fontWeight: "bold",
  };

  const directorsGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
    gap: "20px",
    justifyItems: "center",
    padding: "10px",
  };

  const directorCardStyle = {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
    padding: "20px",
    textAlign: "center",
    width: "100%",
    maxWidth: "300px",
    transition: "all 0.3s ease",
    cursor: "pointer",
  };

  const directorCardHoverStyle = {
    transform: "translateY(-5px)",
    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.15)",
  };

  const directorImageStyle = {
    width: "100px",
    height: "100px",
    borderRadius: "50%",
    objectFit: "cover",
    marginBottom: "15px",
    transition: "all 0.3s ease",
  };

  const directorImageHoverStyle = {
    transform: "scale(1.7)",
  };

  const directorPositionStyle = {
    color: "#c0a875",
    fontWeight: "bold",
    fontSize: "16px",
  };

  return (
    <div style={directorsContainerStyle}>
      <h2 style={directorsTitleStyle}>Board of Directors</h2>
      <div style={directorsGridStyle}>
        {directors.map((director, index) => (
          <div
            key={index}
            style={{
              ...directorCardStyle,
              ...(hoveredIndex === index ? directorCardHoverStyle : {}),
            }}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <img
              src={director.image}
              alt={director.name}
              style={{
                ...directorImageStyle,
                ...(hoveredIndex === index ? directorImageHoverStyle : {}),
              }}
            />
            <h3>{director.name}</h3>
            <p style={directorPositionStyle}>{director.position}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BoardOfDirectors;
